<template>
  <div class="agConn">
    <b-card>
      <template slot="header" >
        <span 
          class="agConn-title" 
          v-b-tooltip.hover
          :title="'Edit ' + connection.name"
          @click="title_click">{{connection.name}}</span>
        <b-dropdown 
          class="agDropdown" 
          no-caret 
          dropleft
          v-b-tooltip.hover
          title="Actions">
          <template slot="button-content">
            <fa icon="cog"/>
          </template>
          <b-dropdown-item v-if="isReadonly" href="#" @click="editConnButton_click"><fa icon="eye"/>View</b-dropdown-item>
          <b-dropdown-item v-else href="#" @click="editConnButton_click"><fa icon="pen"/>Edit</b-dropdown-item>
          <b-dropdown-item href="#" class="danger" :disabled="isReadonly" @click="deleteConnButton_click"><fa icon="ban"/>Delete</b-dropdown-item>
        </b-dropdown>
      </template>
      <div>
        <label class="agConn-label">URL:</label>
        <label class="agConn-value">
          <a :href="connection.url" target="_blank">{{connection.url}}</a>
        </label>
      </div>
      <div v-if="connection.authUrl">
        <label class="agConn-label">Auth URL:</label>
        <label class="agConn-value">
          <a :href="connection.authUrl" target="_blank">{{connection.authUrl}}</a>
        </label>      
      </div>
      <div v-if="connection.username">
        <label class="agConn-label">Username</label>
        <label class="agConn-value">{{connection.username}}</label>
      </div>
    </b-card>
  </div>
</template>





<script>

// components

// modules


export default {
  name: "ag-connection",

  props: {
    connection: Object
  },

  data() {
    return {};
  },

  computed: {

    isReadonly() {
      if(this.user.role == "readonly")
        return true;
      return false;
    },

    user() {
      return this.$store.state.userStore.user;
    }
  },
  
  mounted() {

  },

  methods: {

    // UI Events

    editConnButton_click() {
      this.$emit("editConnection", this.connection);
    },

    deleteConnButton_click() {
      this.$emit("deleteConnection", this.connection);
    },

    title_click()
    {
      this.$emit("editConnection", this.connection);
    }
  }
};
</script>






<style scoped lang="css">

.agConn {
  margin-bottom: 25px;
}

.agConn-ghost .card {
  background-color: rgba(0, 0, 0, 0.15);
}

.agConn .card {
  height: 100%;
  text-align: left;
}

.agConn .card-header {
  color: #4A797C;
  font-weight: bold;
  font-size: 18px;
  cursor: grab;
}

.agConn .card-header:active {
  cursor: grabbing;
}

.agConn-title {
    cursor: pointer;
}

.agConn-title:hover {
    opacity: 0.5;
}

.agConn .agDropdown {
  float: right;
}

.agConn-label {
  width: 100px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/connection/Connection.vue